export const mutations = {
  SET_DISABLED_CONFIRM: "SET_DISABLED_CONFIRM",
  SET_SELECT_ALL: "SET_SELECT_ALL",
  RESET_SELECT_PAGE: "RESET_SELECT_PAGE",
  RESET_DATA: "RESET_DATA",
  PAGE_UPDATE_QUERY: "PAGE_UPDATE_QUERY",
  SET_CHOOSED_PLAN: "SET_CHOOSED_PLAN",
  UPDATE_UNPUBLISH_PAGE_LIST: "UPDATE_UNPUBLISH_PAGE_LIST",
  OPEN_UNPUBLISH_MODAL: "OPEN_UNPUBLISH_MODAL",
  CLOSE_UNPUBLISH_MODAL: "CLOSE_UNPUBLISH_MODAL",
  TOGGLE_BLOCK_MODAL: "TOGGLE_BLOCK_MODAL"
};

export const actions = {
  GET_PUBLISHED_PAGE: "getPublishedPage",
  UNPUBLISH_PAGE: "unpublishPage",
  GET_PUBLISH_PAGE_COUNT: "getPublishPageCount"
};
